<app-loader [Parent]="this"></app-loader>
<div [formGroup]="Form" *ngIf="FormLoaded">
    <app-pageheader [Parent]="this">
        <app-form-save-button [Form]="Form" [Parent]="this" (click)="Save()"></app-form-save-button>
    </app-pageheader>

    <div class="columns">
        <div class="column is-6">
            <article class="panel">
                <p class="panel-heading">
                    Permit Details
                </p>
                <div class="panel-block" style="display: block;">
                    <app-field Label="Permit Type">
                        <div class="control is-expanded mb-2">
                            <div class="select is-fullwidth">
                                <select class="input is-fullwidth" formControlName="ParkingPermitTypeId" (change)="UpdateParkingPermitType()">
                                    <option *ngFor="let c of PermitTypes" [ngValue]="c.Id" [disabled]="c.AvailableCount != null && c.AvailableCount <= 0">
                                        {{c.Name}} ({{c.ActivePermitsCount}}{{c.MaxActivePermits != null && c.MaxActivePermits != 0 ? '/' + c.MaxActivePermits : ''}} used)
                                    </option>
                                </select>
                            </div>
                        </div>
                    </app-field>       
                    <app-field Label="Active From" [HasAddons]="true" tippy="" *ngIf="!ModelIsNew">
                        <div class="control is-expanded mb-2">
                            <input formControlName="StartDateLocal" class="input" type="date"  (change)="Form.markAsDirty()">
                            <app-validator [For]="this.Form.get('StartDateLocal')"></app-validator> 
                        </div>
                    </app-field>
                    <app-field Label="Active Until" [HasAddons]="true" tippy="" *ngIf="!ModelIsNew">
                        <div class="control is-expanded mb-2">
                            <input formControlName="EndDateLocal" class="input" type="date" [readonly]="isMultiUserPermit()"  (change)="Form.markAsDirty()">
                            <app-validator [For]="this.Form.get('EndDateLocal')"></app-validator> 
                        </div>
                    </app-field>
                    <!-- Multi-user permits: ParkingPermitUsers -->
                    <app-field Label="Users" *ngIf="isMultiUserPermit() && !IsAddingNewMultiUser">
                        <div class="control mb-2">
                            <div class="mb-2" *ngFor="let user of FormArray(this.Form, 'ParkingPermitUsers').controls; let i = index;">
                                <div class="tags has-addons">
                                    <a class="tag">{{user.get('FirstName')?.value}} {{user.get('LastName')?.value}} ({{user.get('Email')?.value}})</a>
                                    <a class="tag is-clickable" [ngClass]="{'is-success': user.get('IsPurchaser')?.value, 'is-light': !user.get('IsPurchaser')?.value}" (click)="toggleIsOwner(i)" title="Click to toggle Owner">
                                        <i class="fa" [ngClass]="{'fa-check': user.get('IsPurchaser')?.value}"></i> Owner
                                    </a>
                                    <a class="tag is-clickable" [ngClass]="{'is-info': user.get('IsInvitee')?.value, 'is-light': !user.get('IsInvitee')?.value}" (click)="toggleIsInvitee(i)" title="Click to toggle Invitee">
                                        <i class="fa" [ngClass]="{'fa-check': user.get('IsInvitee')?.value}"></i> Invitee
                                    </a>
                                    <a class="tag is-danger" (click)="removeUser(i)"><i class="fa fa-trash"></i></a>
                                </div>
                            </div>
                            <div class="tags has-addons" *ngIf="canAddUser()">
                                <a class="tag button is-primary" (click)="AddUser()">Add User</a>
                                <a class="tag button is-info" (click)="startAddingNewMultiUser()">Add New User</a>
                            </div>
                        </div>
                    </app-field>
                    <!-- Multi-user permit: New User Entry -->
                    <app-field Label="First Name" *ngIf="isMultiUserPermit() && IsAddingNewMultiUser">
                        <div class="control is-expanded mb-2">
                            <input [(ngModel)]="NewMultiUserFirstName" [ngModelOptions]="{standalone: true}" class="input" type="text" placeholder="First Name">
                        </div>
                    </app-field>
                    <app-field Label="Last Name" *ngIf="isMultiUserPermit() && IsAddingNewMultiUser">
                        <div class="control is-expanded mb-2">
                            <input [(ngModel)]="NewMultiUserLastName" [ngModelOptions]="{standalone: true}" class="input" type="text" placeholder="Last Name">
                        </div>
                    </app-field>
                    <app-field Label="Email Address" *ngIf="isMultiUserPermit() && IsAddingNewMultiUser">
                        <div class="control is-expanded mb-2">
                            <input [(ngModel)]="NewMultiUserEmail" [ngModelOptions]="{standalone: true}" class="input" type="email" placeholder="Email Address">
                        </div>
                    </app-field>
                    <app-field Label="" *ngIf="isMultiUserPermit() && IsAddingNewMultiUser">
                        <div class="control mb-2">
                            <div class="field is-grouped">
                                <div class="control">
                                    <button class="button is-primary" (click)="saveNewMultiUser()" [disabled]="!NewMultiUserFirstName || !NewMultiUserLastName || !NewMultiUserEmail">Save</button>
                                </div>
                                <div class="control">
                                    <button class="button is-danger" (click)="cancelAddingNewMultiUser()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </app-field>
                    <!-- Single-user permit: UserId -->
                    <app-field Label="User" *ngIf="isSingleUserPermit() && !IsAddingNewUser">
                        <div class="control mb-2">
                            <div class="field is-grouped is-grouped-multiline">
                                <div class="tags has-addons" *ngIf="Form.get('UserId')?.value">
                                    <a class="tag">{{Form.get('FullName')?.value}}</a>
                                    <a class="tag" (click)="removeUser()"><i class="fa fa-trash"></i></a>
                                </div>
                                <div class="tags has-addons" *ngIf="canAddUser()">
                                    <a class="tag button is-primary" (click)="AddUser()">Select User</a>
                                    <a class="tag button is-info" (click)="startAddingNewUser()">Add New User</a>
                                </div>
                            </div>
                        </div>
                    </app-field>
                    <!-- Single-user permit: New User Entry -->
                    <app-field Label="First Name" *ngIf="isSingleUserPermit() && IsAddingNewUser">
                        <div class="control is-expanded mb-2">
                            <input formControlName="FirstName" class="input" type="text" placeholder="First Name">
                            <app-validator [For]="this.Form.get('FirstName')"></app-validator>
                        </div>
                    </app-field>
                    <app-field Label="Last Name" *ngIf="isSingleUserPermit() && IsAddingNewUser">
                        <div class="control is-expanded mb-2">
                            <input formControlName="LastName" class="input" type="text" placeholder="Last Name">
                            <app-validator [For]="this.Form.get('LastName')"></app-validator>
                        </div>
                    </app-field>
                    <app-field Label="Email Address" *ngIf="isSingleUserPermit() && IsAddingNewUser">
                        <div class="control is-expanded mb-2">
                            <input formControlName="EmailAddress" class="input" type="email" placeholder="Email Address">
                            <app-validator [For]="this.Form.get('EmailAddress')"></app-validator>
                        </div>
                    </app-field>
                    <app-field Label="" *ngIf="isSingleUserPermit() && IsAddingNewUser">
                        <div class="control mb-2">
                            <div class="field is-grouped">
                                <div class="control">
                                    <button class="button is-danger" (click)="cancelAddingNewUser()">Cancel</button>
                                </div>
                            </div>
                        </div>
                    </app-field>
                    <app-field Label="Limit To Parking Space" *ngIf="this.Model.ParkingPermitType?.LimitToParkingSpace" [HasAddons]="true" tippy="">
                        <div class="control mb-2">
                            <div class="field is-grouped is-grouped-multiline">
                                <div class="tags has-addons">
                                    <a class="tag" *ngIf="this.Form.get('ParkingSpaceLocationString')?.value != null">{{this.Form.get('ParkingSpaceLocationString')?.value}}</a>
                                    <a class="tag button is-primary" (click)="AddParkingSpace()">Add/Change</a>
                                </div>
                            </div>
                        </div>
                    </app-field>
                    <app-field Label="Assigned Vehicles" [HasAddons]="true" tippy="">
                        <div class="control mb-2">
                            <div class="field is-grouped is-grouped-multiline">
                                <div class="field is-grouped is-grouped-multiline">
                                    <div class="tags has-addons" *ngFor="let x of this.Form.get('Vehicles')?.value; let i = index">
                                    <a class="tag">{{x.Color}} {{x.Brand}} {{x.Model}} ({{x.PlateNumber}})</a>
                                    <a class="tag" (click)="RemoveVehicle(i)"><i class="fa fa-trash"></i></a>
                                    </div>
                                    <div class="tags has-addons">
                                        <a class="tag button is-primary" *ngIf="Model.ParkingPermitType?.MaxVehicles == 0 || Model.ParkingPermitType?.MaxVehicles == null || (Model.ParkingPermitType?.MaxVehicles - (Form.get('Vehicles')?.value.length || 0) > 0)" (click)="AddVehicle()">Add</a>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </app-field>
                </div>
            </article>
        </div>
        <div class="column is-6" *ngIf="this.Form.get('ParkingPermitTypeId')?.value != null">
            <article class="panel">
                <p class="panel-heading">
                    {{Model.ParkingPermitType?.Name}}
                </p>
                <div class="panel-block">
                    <span class="label">Active Dates</span>
                    <span class="value"><app-daterangedisplay FieldName="Active Dates" [StartDate]="Model.ParkingPermitType?.ActiveStartDateLocalFriendlyString" [EndDate]="Model.ParkingPermitType?.ActiveEndDateLocalFriendlyString"></app-daterangedisplay></span>
                </div>
                <div class="panel-block">
                    <span class="label">Price</span>
                    <span class="value">{{Model.ParkingPermitType?.PriceString}}</span>
                </div>
                <div class="panel-block">
                    <span class="label">Users</span>
                    <span class="value">{{BuildUsersString()}}</span>
                </div>
                <div class="panel-block">
                    <span class="label">Restrictions</span>
                    <span class="value" style="width:65%"><div class="is-display" [innerHtml]="Model.ParkingPermitType?.Restriction" style="font-size:small;"></div></span>
                </div>
                <div class="panel-block">
                    <span class="label">Confirmations</span>
                    <span class="value">{{(Model.ParkingPermitType?.RequireConfirmations ? 'Confirmation by members required within ' + Model.ParkingPermitType?.MaxConfirmationDistance + orgService.KMorMiles() : 'Not Required')}}</span>
                </div>
            </article>
        </div>
    </div>